import { cx } from '@linaria/core';
import { useQuery } from '@tanstack/react-query';
import { TransitionGroup } from 'react-transition-group';
import { USER_AREA_BASE_PATH } from '@pm2/api';
import { useNavigationManager } from '@provider/navigation';
import { breakpoints } from '@ui/css';
import { Chip } from '@ui/kit';
import { TeamsIcon } from '@ui/kit/icons';
import { SizeTransition, ShowFor, HideFor } from '@utils/react';
import { MobileSearch } from '../../../atoms/search.mobile.js';
import { Routes } from '../../../const.routes.js';
import { getTeamsQuery } from '../../settings/molecule.my-teams/api.get-teams.query.js';
import { heading, header } from '../../shared.header.style.js';
import { componentEntryStore } from '../state.js';
import { TeacherEmptyState } from './atom.empty-state.js';
import { useWelcomeNoticeState, WelcomeNotice } from './atom.welcome-notice.js';
import { TeacherTablist } from './molecule.tablist.js';
import { transitionWrapper, section, transitionDurationMs, spacer, chip, header as header$1, mobileActions, mobileFiltersBreakpoint } from './root.style.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { Filters } from '../molecules/filters/filters.js';
import { MobileFilters } from '../molecules/filters/filters.mobile.js';

function TeacherEntriesView(props) {
  const navigation = useNavigationManager();
  const teams = useQuery(getTeamsQuery.useQueryConfig());
  const showEmptyMessage = teams.isSuccess && teams.data.length === 0;
  const welcomeNoticeState = useWelcomeNoticeState(showEmptyMessage);
  return /*#__PURE__*/jsx("div", {
    ref: props.ref,
    className: transitionWrapper,
    children: /*#__PURE__*/jsx(TransitionGroup, {
      component: null,
      children: /*#__PURE__*/jsx(SizeTransition, {
        timeout: transitionDurationMs,
        axis: "vertical",
        swappable: true,
        classNames: section,
        children: ref => /*#__PURE__*/jsxs("section", {
          ref: ref,
          className: section,
          children: [/*#__PURE__*/jsx(WelcomeNotice, {
            active: welcomeNoticeState.active,
            onDismiss: () => welcomeNoticeState.onDismiss()
          }), /*#__PURE__*/jsxs("header", {
            className: cx(header, header$1),
            children: [!showEmptyMessage && /*#__PURE__*/jsx("div", {
              className: spacer
            }), /*#__PURE__*/jsx("h1", {
              className: heading,
              children: "Besvarelser"
            }), !showEmptyMessage && /*#__PURE__*/jsxs(Chip, {
              className: cx(chip, welcomeNoticeState.active && "hidden"),
              onClick: () => navigation.push(`${USER_AREA_BASE_PATH}/${Routes.TEAMS}`),
              children: [/*#__PURE__*/jsx(TeamsIcon, {
                height: "1.6rem"
              }), "Mine hold"]
            })]
          }), /*#__PURE__*/jsxs("div", {
            className: mobileActions,
            children: [/*#__PURE__*/jsx(ShowFor, {
              breakpoint: breakpoints.mobile,
              children: /*#__PURE__*/jsx(MobileSearch, {
                label: "S\xF8g i besvarelser",
                onQueryChange: newQuery => componentEntryStore.dispatch(componentEntryStore.actions.setQuery(newQuery))
              })
            }), /*#__PURE__*/jsx(ShowFor, {
              breakpoint: mobileFiltersBreakpoint,
              children: /*#__PURE__*/jsx(MobileFilters, {
                withTimespan: true,
                withTeams: true,
                withStudents: true,
                withProducts: true
              })
            })]
          }), showEmptyMessage ? /*#__PURE__*/jsx(TeacherEmptyState, {}) : /*#__PURE__*/jsxs(Fragment, {
            children: [/*#__PURE__*/jsx(HideFor, {
              breakpoint: mobileFiltersBreakpoint,
              children: /*#__PURE__*/jsx(Filters, {
                withTimespan: true,
                withTeams: true,
                withStudents: true,
                withProducts: true
              })
            }), /*#__PURE__*/jsx(TeacherTablist, {})]
          })]
        })
      }, `${showEmptyMessage}`)
    })
  });
}

export { TeacherEntriesView };
//# sourceMappingURL=root.js.map
